// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"8d335ebc","239":"5c80efa7","248":"ccd0c9a0","453":"a9924af9","527":"6d7188d5","732":"40aec2d6","798":"f36216b9","977":"2aa82dab"}[chunkId] + ".chunk.js";
};